// Template Generated by DataExtraction.py at 1716507313
        
import CesgMaxEnglish from "../../Forms/CESG Max/CesgMax-English.png";
import CesgMaxEnglishLabels from "../../Labels/CESG Max/CesgMax-English.json";
import CesgMaxFrench from "../../Forms/CESG Max/CesgMax-French.png";
import CesgMaxFrenchLabels from "../../Labels/CESG Max/CesgMax-French.json";
import {
    defaultFontSize,
    drawTextOnLabel,
    fillCheckboxAtLabel,
    standardFormAlias,
    standardFormCompression,
    isLanguageEnglish,
    standardFormFormat,
    standardFormHeight,
    standardFormWidth,
    standardFormX,
    standardFormY,
    signatureLabel, 
    signatureTab
} from "../../PDFGenerationUtils";
import {POSSIBLE_SIGNERS} from "../../../Utils/PlanUtils";

import moment from "moment/moment";

/*
 * @param doc {jsPDF}
 */
const generate = (doc, data, quote, authStatus, i18n) => {

    const isFrench = !isLanguageEnglish(i18n);
    const labels = isFrench ? CesgMaxFrenchLabels : CesgMaxEnglishLabels;
    const formImage = isFrench ? CesgMaxFrench : CesgMaxEnglish;

    function fillCheckbox(value, label){
        fillCheckboxAtLabel(doc, value, label, labels);
    }
    
    function drawText(value, label){
        drawTextOnLabel(doc, value, label, labels);
    }

    // add image
    doc.addImage(formImage, standardFormFormat, labels["image"]["x"], labels["image"]["y"], labels["image"]["width"], labels["image"]["height"], null, standardFormCompression);

    const common = data.common;
    /* define state variables here ie:
     * const subscriber = data.subscriber;
     * const jointSubscriber = data.jointSubscriber;
     * const beneficiary = data.beneficiary;
    */

    // Drawing the form


    const signDate = moment(new Date()).format("YYYY-MM-DD");

    drawText(signDate, "s1Date");
    if (common.subscriber2Include) {
        drawText(signDate, "s2Date");
    }

}

//Returns the signature definitions for the document
// This includes who needs to sign and where
const signatureDefinitions = (state, documentId, pageNumber, i18n) => {
    const isFrench = !isLanguageEnglish(i18n);
    const labels = isFrench ? CesgMaxFrenchLabels : CesgMaxEnglishLabels;
    const DRRecipientId = POSSIBLE_SIGNERS['Dealing Representative'];
    const subscriberRecipientId = POSSIBLE_SIGNERS['Subscriber'];
    const jointSubscriberRecipientId = POSSIBLE_SIGNERS['Joint Subscriber'];
    let signers = [];
    let signHereTabs = [];
    const subscriber2Include = state.common.subscriber2Include;
    
    // s1Signature
    signers.push({
        [subscriberRecipientId]: [signatureTab(subscriberRecipientId, documentId, pageNumber, signatureLabel("s1Signature", labels))],
    });
    

    if (subscriber2Include) {
        // s2Signature
        signers.push({
            [jointSubscriberRecipientId]: [signatureTab(jointSubscriberRecipientId, documentId, pageNumber, signatureLabel("s2Signature", labels))],
        });
    }
    
    
    return signers;
}

export default {
    generate,
    signatureDefinitions
}
    